(function () {
	'use strict';
	document.addEventListener('DOMContentLoaded', function () {
		var content = document.querySelector('.p-columnSingle__content');
		var toc = document.querySelector('.js-toc');
		var tocBody = document.querySelector('.js-toc-body');
		if (!content || !toc || !tocBody) return;

		var headings = content.querySelectorAll('h2, h3');
		if (!headings.length) return; // 見出しが無ければ目次を出さない

		var list = document.createElement('ul');
		list.className = 'p-columnSingle__tocList';

		var itemsById = {};
		headings.forEach(function (h, i) {
			if (!h.id) h.id = 'toc-' + i;
			var li = document.createElement('li');
			li.className = 'p-columnSingle__tocItem p-columnSingle__tocItem--' + h.tagName.toLowerCase();
			var a = document.createElement('a');
			a.href = '#' + h.id;
			a.textContent = h.textContent;
			a.className = 'p-columnSingle__tocLink';
			a.addEventListener('click', function (e) {
				e.preventDefault();
				var target = document.getElementById(h.id);
				if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
				history.replaceState(null, '', '#' + h.id);
			});
			li.appendChild(a);
			list.appendChild(li);
			itemsById[h.id] = li;
		});

		tocBody.appendChild(list);
		toc.hidden = false; // 生成できたら表示

		// スクロール追従：現在地の見出しに対応する目次項目をハイライト（ドットをオレンジに）
		var activeClass = 'p-columnSingle__tocItem--active';
		function setActive(id) {
			Object.keys(itemsById).forEach(function (key) {
				itemsById[key].classList.toggle(activeClass, key === id);
			});
		}

		if ('IntersectionObserver' in window) {
			var visible = {};
			var observer = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					visible[entry.target.id] = entry.isIntersecting;
				});
				// 画面内にある見出しのうち最も上のものをアクティブにする
				for (var i = 0; i < headings.length; i++) {
					if (visible[headings[i].id]) {
						setActive(headings[i].id);
						return;
					}
				}
			}, { rootMargin: '0px 0px -70% 0px', threshold: 0 });

			headings.forEach(function (h) {
				observer.observe(h);
			});
		}
	});
})();
